import { API_CALLS } from "@/services/apis/index.js";

export default {
  filterFlashSales(context, filter) {
    console.log('🏪 Categories being sent:', filter.categories);
    console.log('🏪 [Store] filterFlashSales action called');
    console.log('🏪 [Store] Filters to be passed to API:', filter);
    return new Promise((resolve, reject) => {
      API_CALLS.filterFlashSalesAPI(filter)
        .then((response) => {
          console.log('🏪 [Store] API call successful, resolving promise');
          console.log(`🏪 [Store] Received ${response.data.length} products`);
          resolve(response);
        })
        .catch((error) => {
          console.error('🏪 [Store] API call failed, rejecting promise');
          console.error('🏪 [Store] Error:', error);
          reject(error);
        });
    });
  },
  putWholesalePrices(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.putWholesalePricesAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSizes(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.getSizesAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSpreadsheet(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.getSpreadsheetAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  exportFlashSales(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.exportFlashSalesAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  checkGoogleToken() {
    return new Promise((resolve, reject) => {
      API_CALLS.checkGoogleTokenAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postNewToken(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.postNewTokenAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
